import React from "react";
import Header from "../../Components/Header/Header";

function EscalationJob() {
  return (
    <div className="app has-fullwidth">
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Canceled Jobs</span>
                    </p>
                  </div>
                </header>
                <div className="page-section">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="card card-body">
                        <div
                          id="example_wrapper"
                          className="dataTables_wrapper dt-bootstrap4 no-footer"
                        >
                          <div className="row">
                            <div className="col-sm-12 col-md-6">
                              <div
                                className="dataTables_length"
                                id="example_length"
                              >
                                <label>
                                  Show{" "}
                                  <select
                                    name="example_length"
                                    aria-controls="example"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                  >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                  </select>{" "}
                                  entries
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                              <div
                                id="example_filter"
                                className="dataTables_filter"
                              >
                                <label>
                                  Search:
                                  <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search here..."
                                    aria-controls="example"
                                    style={{
                                      width: "300px",
                                      display: "inline-block",
                                    }}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <table
                                id="example"
                                className="table table-hover responsive nowrap dataTable no-footer dtr-inline collapsed"
                                style={{ width: "100%" }}
                                role="grid"
                                aria-describedby="example_info"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      hidden=""
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "0px;" }}
                                      aria-label="order: activate to sort column ascending"
                                    >
                                      order
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "42px;" }}
                                      aria-label="Job id: activate to sort column ascending"
                                    >
                                      Job id
                                    </th>
                                    <th
                                      hidden=""
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "0px;" }}
                                      aria-label="SP Name: activate to sort column ascending"
                                    >
                                      SP Name
                                    </th>
                                    <th
                                      hidden=""
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "0px;" }}
                                      aria-label="Finel Amount: activate to sort column ascending"
                                    >
                                      Finel Amount
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "65px;" }}
                                      aria-label="SP Name: activate to sort column ascending"
                                    >
                                      SP Name
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "170px;" }}
                                      aria-label="Scheduled Date &amp;amp; Time: activate to sort column ascending"
                                    >
                                      Scheduled Date &amp; Time
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{
                                        width: "32px",
                                        display: "none;",
                                      }}
                                      aria-label="HUB: activate to sort column ascending"
                                    >
                                      HUB
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "65px", display: "none" }}
                                      aria-label="Category: activate to sort column ascending"
                                    >
                                      Category
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{
                                        width: "124px",
                                        display: "none",
                                      }}
                                      aria-label="Customer details: activate to sort column ascending"
                                    >
                                      Customer details
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{
                                        width: "132px",
                                        display: "none",
                                      }}
                                      aria-label="Customer Address: activate to sort column ascending"
                                    >
                                      Customer Address
                                    </th>
                                    <th
                                      className="sorting"
                                      tabindex="0"
                                      aria-controls="example"
                                      rowspan="1"
                                      colspan="1"
                                      style={{ width: "47px;" }}
                                      aria-label="Action: activate to sort column ascending"
                                    >
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  <tr className="odd">
                                    <td
                                      valign="top"
                                      colspan="4"
                                      className="dataTables_empty"
                                    >
                                      No data available in table
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-5">
                              <div
                                className="dataTables_info"
                                id="example_info"
                                role="status"
                                aria-live="polite"
                              >
                                Showing 0 to 0 of 0 entries
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                              <div
                                className="dataTables_paginate paging_simple_numbers"
                                id="example_paginate"
                              >
                                <ul className="pagination">
                                  <li
                                    className="paginate_button page-item previous disabled"
                                    id="example_previous"
                                  >
                                    <a
                                      href="#"
                                      aria-controls="example"
                                      data-dt-idx="0"
                                      tabindex="0"
                                      className="page-link"
                                    >
                                      Previous
                                    </a>
                                  </li>
                                  <li
                                    className="paginate_button page-item next disabled"
                                    id="example_next"
                                  >
                                    <a
                                      href="#"
                                      aria-controls="example"
                                      data-dt-idx="1"
                                      tabindex="0"
                                      className="page-link"
                                    >
                                      Next
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default EscalationJob;
